<div class="clinic-map-wrapper">
    <!-- Painel lateral de filtros -->
    <div class="location-filters" [class.d-none]="!showFilters && isMobileView">
      <div class="filter-header">
        <h3>Filtrar Clínicas</h3>
        <div class="filter-actions">
          <button (click)="toggleAllLocations(true)" class="filter-btn">Marcar todos</button>
          <button (click)="toggleAllLocations(false)" class="filter-btn">Desmarcar todos</button>
        </div>
      </div>
      
      <div class="search-box">
        <input 
          type="text" 
          placeholder="Buscar clínica..." 
          [(ngModel)]="searchTerm" 
          (input)="filterLocations()"
          class="search-input">
      </div>
      
      <div class="filter-stats">
        <span>{{ filteredLocationsList.length }} de {{ locationsList.length }} clínicas</span>
        <div class="filter-hint">
          <small><i>Somente clínicas marcadas serão exibidas no mapa</i></small>
        </div>
      </div>
  
      <div class="location-list">
        <div *ngIf="filteredLocationsList.length === 0" class="no-results">
          Nenhuma clínica encontrada para "{{ searchTerm }}"
        </div>
        
        <div *ngFor="let loc of filteredLocationsList" class="location-item">
          <div class="location-checkbox">
            <input 
              type="checkbox" 
              [id]="'loc-' + loc.id" 
              [(ngModel)]="loc.visible" 
              (change)="updateVisibleLocations()">
            <label [for]="'loc-' + loc.id" class="location-label">
              <span class="location-name">{{ loc.name }}</span>
            </label>
          </div>
        </div>
        
        <div class="extra-space"></div>
      </div>
      
      <div class="bottom-button-container" *ngIf="isMobileView">
        <button (click)="toggleFiltersPanel()" class="close-filters-btn">
          Aplicar e Voltar ao Mapa
        </button>
      </div>
    </div>
  
    <div class="clinic-map-container">
      <button class="toggle-filters-btn d-md-none" (click)="toggleFiltersPanel()">
        {{ showFilters ? 'Fechar Filtros' : 'Filtrar Mapa' }} 
        <span class="toggle-icon">{{ showFilters ? '✖' : '▼' }}</span>
      </button>
      
      <div *ngIf="isLoading" class="loading-container">
        <div class="loading-message">Carregando dados do mapa...</div>
      </div>
  
      <div *ngIf="error && !isLoading" class="error-container">
        <div class="error-message">{{ error }}</div>
        <button (click)="recarregarDados()" class="retry-button">Tentar novamente</button>
      </div>
  
      <div *ngIf="!isLoading && !error && visibleLocations.length === 0" class="no-data-container">
        <div class="no-data-message">
          <p>Nenhuma clínica visível no mapa.</p>
          <p>Marque pelo menos uma clínica no painel de filtros.</p>
        </div>
        <button (click)="toggleAllLocations(true)" class="retry-button">Marcar todas</button>
      </div>
  
      <div id="clinic-map" class="map-container"></div>
  
      <div class="legend">
        <h4>Clínicas por Região</h4>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #fffaf8; width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: #333; font-weight: bold; font-size: 9px;">&lt;5</div>
          <span>Menos de 5</span>
        </div>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #ffcdb2; width: 26px; height: 26px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: #333; font-weight: bold; font-size: 9px;">7</div>
          <span>5 - 10</span>
        </div>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #ffa06b; width: 30px; height: 30px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 9px;">15</div>
          <span>11 - 20</span>
        </div>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #ff8948; width: 34px; height: 34px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 9px;">35</div>
          <span>21 - 50</span>
        </div>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #d36f42; width: 38px; height: 38px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 8px;">75</div>
          <span>51 - 100</span>
        </div>
        <div class="legend-item">
          <div class="marker-example" style="background-color: #ab5e3c; width: 42px; height: 42px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 8px;">100+</div>
          <span>Mais de 100</span>
        </div>
        <div class="legend-note">
          <small><i>💡 Clique em qualquer marcador para ver detalhes</i></small>
          <small><i>🔍 Grupos mostram total de clínicas agrupadas</i></small>
        </div>
      </div>
    </div>
  </div>
